import { gql } from '@apollo/client'

export const GET_FOLLOWED_PROJECTS = gql`
  query ($limit: Int, $offset: Int, $sort: Boolean, $filters: CampaignsFilters) {
    getCampaigns(limit: $limit, offset: $offset, sort: $sort, filters: $filters) {
      artists {
        name
        spotify_id
        facebook_id
        campaigns {
          id
          name
          owner_id
        }
      }
    }
  }
`
